(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

$( document ).ready(function() {

  $('#myBtn').click(function(e) {
     $("#more").addClass( "myshow" );
     $("#myBtn").addClass( "hide" );
     $('#myBtn1').removeClass("hide");
  }); 

    $('#myBtn1').click(function(e) {
       $("#more").removeClass( "myshow" );
       $("#myBtn").removeClass( "hide" );
       $('#myBtn1').addClass("hide");
  }); 
 if(window.outerWidth < 768) {
     
        $('.custom-footer-content').css('display','none');
        $('.footer-block-title').click(function(){
        var $this = $(this);
          if ($this.parent().find('.custom-footer-content').is(":visible")) {
            $this.parent().find('.custom-footer-content').slideUp(350);
            $this.removeClass("open");
          } else {
            $this.parent().find('.custom-footer-content').slideDown(350);
            $this.addClass("open");
          }
       }); 

 
    }
 
 
});
   

  } catch(e) { console.error(e); }
})();
})();
